import { useEffect, useMemo } from 'react';
import { useGetTripsTaxiQuery } from '../../../GraphQL/hooks/useGetTripsTaxiQuery';
import { useOverviewLinkState } from '../linkstate/tripsTaxiOverview.linkstate';
import { PlanTaxiRequestQueryFilter, Trip } from '../../../shared/types';
import { chunk, isEmpty, isString } from 'lodash';
import { usePageState } from '../../../Hooks/usePageState';
import { useUserState } from '../../../Hooks/useUserState';

const pageSize = 10;
const getPageCount = (trips: Trip[]) => Math.ceil(trips?.length / pageSize);
const getCurrentPage = (requestedPage: number, trips: Trip[]) => {
    const pageCount = getPageCount(trips);
    return requestedPage < 1 ? 1 : requestedPage > pageCount ? pageCount : requestedPage;
};

export const useSortedTripsTaxiQuery = () => {
    const { setLoading } = usePageState();
    const [state, setState] = useOverviewLinkState();
    const { ...userState } = useUserState();
    const { page, pageSize, quickStatusFilter, selectedDateRange, search } = state;

    const request = useMemo(
        () =>
            ({
                search: search ?? '',
                status: quickStatusFilter ?? '',
                dateRange: selectedDateRange,
                page: page ?? 1,
                limit: pageSize ?? 10,
            }) as PlanTaxiRequestQueryFilter,
        [quickStatusFilter, selectedDateRange, search, pageSize, page]
    );
    useEffect(() => {
        refetch({ request });
    }, [search, quickStatusFilter, selectedDateRange]);
    
    const { data: tripsPage, refetch, loading } = useGetTripsTaxiQuery(request);
    
    useEffect(() => setLoading(loading), [loading]);

 

 
    return {

        sortedTrips: tripsPage?.data ?? [],
        pageCount: tripsPage?.pagination?.pageCount ?? 1,
        totalCount: tripsPage?.pagination?.totalCount ?? 0,
        page: tripsPage?.pagination?.page ?? 1,
        pageSize: pageSize,
        setPage: (newPage: number) => setState({ ...state, page: newPage }),
        setPageSize: (pageSize: number) => setState({ ...state, pageSize: pageSize }),
        refetch: () => refetch({ request }),
        loading,
    };
};
